// Rotas de autenticacao que sao publicas no Strapi (login, cadastro, recuperacao
// de senha e os fluxos do Google).
//
// Elas NAO tem `auth: false` no plugin users-permissions: passam pela estrategia
// de autenticacao normal. Se a requisicao chegar com um Authorization invalido
// (cookie `jwt` expirado ou assinado com outro JWT_SECRET), a estrategia falha
// antes do controller e o Strapi devolve 401 "Missing or invalid credentials" —
// mesmo para quem so esta tentando criar uma conta. Sem header a mesma chamada
// responde 200.
//
// Por isso os interceptors nunca anexam o token nestas rotas.
const PUBLIC_AUTH_PATHS = [
  '/api/auth/local',
  '/api/auth/local/register',
  '/api/auth/forgot-password',
  '/api/auth/reset-password',
  '/api/auth/send-email-confirmation',
  '/api/auth/email-confirmation',
  '/api/auth/google/',
  '/api/connect/',
];

export const isPublicAuthRoute = (url = '') => {
  // `url` pode vir absoluta (baseURL + path) ou relativa; comparamos so o caminho.
  const path = String(url).replace(/^https?:\/\/[^/]+/, '').split('?')[0];
  return PUBLIC_AUTH_PATHS.some((p) => (p.endsWith('/') ? path.startsWith(p) : path === p));
};

export default isPublicAuthRoute;
